import moment from 'moment';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { TLogbookPersonnel } from 'redux/app/vessel/inspector/types';
import { IStore } from 'redux/store';

type OwnProps = {
    personnels?: TLogbookPersonnel[];
    title: string;
};
type TKTableProps = PropsFromRedux & OwnProps;
function TKTable(props: TKTableProps) {
    const { personnels, title } = props;
    let emptyDataScenario: React.ReactNode = <></>;
    if (!personnels?.length) {
        emptyDataScenario = (
            <tr>
                <td className="text-center text-gray-500 p-2" colSpan={6}>
                    No personnel
                </td>
            </tr>
        );
    }
    return (
        <>
            <p className="mb-4">{title}</p>
            <table className="table-auto w-full preserve-tablestylesin-pagedjs">
                <thead className="border border-gray-500">
                    <tr>
                        <th rowSpan={2} className="p-2 border border-gray-500">
                            NAME
                        </th>
                        <th
                            className="p-2 text-center border border-gray-500"
                            colSpan={2}
                        >
                            Date On Board
                        </th>
                        <th
                            className="p-2 text-center border border-gray-500"
                            colSpan={3}
                        >
                            Certificate
                        </th>
                    </tr>
                    <tr>
                        <th className="p-2 print-0.5 border border-gray-500">
                            From
                        </th>
                        <th className="p-2 print-0.5 border border-gray-500">
                            To
                        </th>
                        <th className="p-2 print-0.5 border border-gray-500">
                            Class
                        </th>
                        <th className="p-2 print-0.5 border border-gray-500">
                            Date Of Issue
                        </th>
                        <th className="p-2 print-0.5 border border-gray-500">
                            Certificate Number
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {emptyDataScenario}
                    {personnels?.map((row, index: number) => {
                        const {
                            name,
                            onboard_date,
                            offboard_date,
                            class_certificate,
							certificateNumber,
                            date_of_issue,
                        } = row;
                        return (
                            <tr key={index}>
                                <td className="p-0.5 border border-gray-500">
                                    {name}
                                </td>
                                <td className="p-0.5 border border-gray-500">
									{onboard_date ? onboard_date.split('T')[0] : 'NA'}
                                </td>
                                <td className="p-0.5 border border-gray-500">
									{offboard_date ? offboard_date.split('T')[0] : 'NA'}
                                </td>
                                <td className="p-0.5 border border-gray-500">
                                    {class_certificate}
                                </td>
                                <td className="p-0.5 border border-gray-500">
									{date_of_issue ? date_of_issue.split('T')[0] : 'NA'}
                                </td>
                                <td className="p-0.5 border border-gray-500">
                                    {certificateNumber}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </>
    );
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
    return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(TKTable);
